import type { PopoverName } from '@widgets/messenger/types/popover'
import { messengerBroadcastEventEmitterService } from '@widgets/messenger/services/messengerBroadcastEventEmitterService'

const widgetPopoverClosedEventCode = 'widgetPopoverClosed'

export const useWidgetBroadcastEvents = () => {
  const emitPopoverClosed = (name: PopoverName) => {
    messengerBroadcastEventEmitterService.emit(widgetPopoverClosedEventCode, name)
  }

  const onPopoverClosed = (callback: (name: PopoverName) => void) => {
    return messengerBroadcastEventEmitterService.on(widgetPopoverClosedEventCode, callback, {
      receiveOwnMessages: false,
    })
  }

  const removeSubscription = (subscriptionId: string) => {
    messengerBroadcastEventEmitterService.remove(subscriptionId)
  }

  return {
    emitPopoverClosed,
    onPopoverClosed,
    removeSubscription,
  }
}
